import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="redirect-loading"
// For links/buttons that navigate the browser to an external/slow destination
// (e.g. Stripe Connect). On click, shows a loading state so the user knows
// something is happening while the redirect is in flight.
//
//   <a data-controller="redirect-loading"
//      data-redirect-loading-label-value="Redirecting…"
//      data-action="click->redirect-loading#start"> Set up payments </a>
export default class extends Controller {
  static values = { label: String }

  start(event) {
    // Let the navigation proceed; just reflect that we're going somewhere.
    if (this.element.dataset.redirecting === "true") {
      // Already clicked — prevent a second navigation.
      event.preventDefault()
      return
    }
    this.element.dataset.redirecting = "true"
    this.element.classList.add("is-redirecting")
    this.element.setAttribute("aria-busy", "true")

    const label = this.hasLabelValue ? this.labelValue : "Redirecting…"
    // Keep a spinner + label; pointer-events off so it can't be re-clicked.
    this.element.style.pointerEvents = "none"
    this.element.innerHTML = `<span class="redirect-spinner" aria-hidden="true"></span>${label}`
  }
}
